import { render, staticRenderFns } from "./Writeinspectionrecords.vue?vue&type=template&id=7b7a9a76&"
import script from "./Writeinspectionrecords.vue?vue&type=script&lang=js&"
export * from "./Writeinspectionrecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports